// libraries
import { gql, GraphQLClient } from 'graphql-request';
import { BASE_URL, headers } from '../configs/constants';

// requests
export async function cities_types(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            cidades {
                id
                nome
                id_estado
                url_foto
            }
            tipos {
                id
                nome
            }
        }
    `;
    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function categorias(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            categorias {
                id
                nome
            }
        }
    `;
     try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function get_estados(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            estados {
                id
                nome
            }
        }
    `;
     try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function allCaracteristicas(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            caracteristicas {
                id
                nome
                imovel
                condominio
            }
        }
    `;
     try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function allDatasEntrega(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            datas_entrega
        }
    `;
     try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function getCompany(nameCompany?: string, origin?: string, codsite?: number, mostrar_site?: boolean) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            empreendimentos(nome: ${JSON.stringify(nameCompany || '')} ${mostrar_site ? `,mostrar_site: ${mostrar_site}` : ''}) {
                id
                nome
                Estado
                Pais
                referencia
                endereco
                construtora
                cep
                id_estado
                id_cidade
                id_bairro
                latitude_longitude
                unidades
                unidades_andar
                torres
                andares
                mostrar_site
                destaque
                foto_360
                meta_description
                meta_keywords
                meta_title
                descricao
                situacao
                porcentagem_vendido
                porcetagem_praca_alimentacao
                porcetagem_estrutura
                porcetagem_telhado
                porcetagem_areade_entrada
                preco_min
                preco_max
                area_privativa_min
                area_privativa_max
                fotos {
                  id
                  descricao
                  posicao
                  destaque
                  id_empreendimento
                  tipo
                  banner
                  url_foto
                }
            }
        }
    `;

     try {
        
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function getCompany_rodape(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            rodape {
                tipo
                cidade
                bairro
                dormitorios
                aluguel
                venda
                empreendimento
            }
        }
    `;

     try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function district(idCity: number, origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });
    const query = gql`
        {
            bairros(id_cidade: ${idCity}) {
                id
                nome
                id_cidade
            }
        }
    `;

     try {
        
        const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function getFilterPrices(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            precos_locacao {
                min
                max
            }
            precos_venda {
                min
                max
            }
        }
    `;

     try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}
